import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { Button } from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface BackButtonProps {
  buttonLabel: string;
  buttonLink: string;
}

const BackButton: FC<BackButtonProps> = (props) => {
  let history = useHistory();
  let { buttonLabel, buttonLink } = props;

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={() => history.push(buttonLink)}
      variant="outlined"
      color="primary"
      style={{ paddingTop: 2, paddingRight: 10, paddingBottom: 2, paddingLeft: 10 }}
    >
      {buttonLabel}
    </Button>
  );
};

export default BackButton;
